import { Wrapper } from 'AppReact';
import styled from 'styled-components';

const template = styled.div`
  border: 1px solid #E3E3E3;
  box-shadow: 0px 1px 2px #00000014;
  border-radius: 12px;
  margin-bottom: 10px;
  padding: 16px;
`;

export default Wrapper(template);